import { render, staticRenderFns } from "./ImageGalleryEditorItem.vue?vue&type=template&id=965efa3c&scoped=true"
import script from "./ImageGalleryEditorItem.vue?vue&type=script&lang=js"
export * from "./ImageGalleryEditorItem.vue?vue&type=script&lang=js"
import style0 from "./ImageGalleryEditorItem.vue?vue&type=style&index=0&id=965efa3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "965efa3c",
  null
  
)

export default component.exports